import { useState } from "react";
import "./UserCard.scss";
import {
  MemberDto,
  MemberDtoInvitationStatusEnum,
} from "../../../generated/account-client";
import { MenuInfo } from "rc-menu/lib/interface";
import { Button } from "../misc/Button";
import { Dropdown, Menu } from "antd";
import Avatar from "./../Avatar";
import { EllipsisOutlined } from "@ant-design/icons";
import RemoveUserModal from "../modal/RemoveUserModal";
import EditLocationAccessModal from "../modal/EditLocationAccessModal";

export interface UserCardProps {
  member: MemberDto;
  loading: boolean;
  onRevoke: (member: MemberDto) => void;
  onResend: (member: MemberDto) => void;
  onRemove: (member: MemberDto) => void;
  onChangeLocationAccess: (member: MemberDto, locations: Set<string>, callback?: () => void) => void;
}

export default function UserCard({
  member,
  loading,
  onRevoke,
  onResend,
  onRemove,
  onChangeLocationAccess,
}: UserCardProps) {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [showRemoveUserModal, setShowRemoveUserModal] = useState(false);
  const [showLocationAccessModal, setShowLocationAccessModal] = useState(false);

  const toggleDropdown = (info: MenuInfo) => {
    info.domEvent.stopPropagation();
    info.domEvent.preventDefault();
    switch (+info.key) {
      case 0:
        setIsDropdownVisible(false);
        onResend(member);
        return;
      case 1:
        setIsDropdownVisible(false);
        setShowRemoveUserModal(true);
        return;
      case 2:
        setIsDropdownVisible(false);
        setShowLocationAccessModal(true);
        return;
      case 3:
        setIsDropdownVisible(false);
        setShowRemoveUserModal(true);
        return;
    }
  };

  const menu = (
    <Menu className={"is-primary-menu"} onClick={toggleDropdown}>
      <Menu.Item key="0">Resend Invitation</Menu.Item>
      <Menu.Item key="1">Cancel Invitation</Menu.Item>
    </Menu>
  );

  const menuActiveUser = (
    <Menu className={"is-primary-menu"} onClick={toggleDropdown}>
      <Menu.Item key="2">Change Settings</Menu.Item>
      <Menu.Item key="3">Remove Access</Menu.Item>
    </Menu>
  );

  function onChangeLocationAccessDone(member: MemberDto, locations: Set<string>) {
    onChangeLocationAccess(member, locations, function() { setShowLocationAccessModal(false) });
  }

  return (
    <div className={"card user-card"}>
      <Dropdown
        placement="bottomRight"
        arrow={false}
        visible={isDropdownVisible}
        className={"card-dropdown"}
        overlay={
          member.invitationStatus === MemberDtoInvitationStatusEnum.Active
            ? menuActiveUser
            : menu
        }
        trigger={["click"]}
        onVisibleChange={() => setIsDropdownVisible(!isDropdownVisible)}
      >
        <Button id={member.id} type={"Link"}>
          <EllipsisOutlined />
        </Button>
      </Dropdown>

      <div className={"gray-rect"} />
      <Avatar member={member} />
      <h5 className={"name"}>
        {member.invitationStatus === MemberDtoInvitationStatusEnum.Active &&
          member.name}
        {member.invitationStatus === MemberDtoInvitationStatusEnum.Invited &&
          "Invitation Pending"}
      </h5>
      <h5 className="email">{member.email}</h5>

      <RemoveUserModal
        member={member}
        visible={showRemoveUserModal}
        onCancel={() => setShowRemoveUserModal(false)}
        onRemove={
          member.invitationStatus === MemberDtoInvitationStatusEnum.Active
            ? onRemove
            : onRevoke
        }
      />

      <EditLocationAccessModal
        member={member}
        visible={showLocationAccessModal}
        loading={loading}
        onCancel={() => setShowLocationAccessModal(false)}
        onChange={onChangeLocationAccessDone}
      />
    </div>
  );
}
